var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import axios from 'axios';
import { keysToCamel, keysToSnake } from 'utils/converter';
import { getKycFileUser, getKycUser, getKycUserAnswer, updateKycUser, updateKycUserAnswer, uploadKycFileUser, } from 'services/network/api/kyc';
import isUser, { formatPersonalDetailsForBackend, formatPersonalResidenceForBackend, isUserAnswers, isUserFile, isUserFiles, } from 'services/network/adapters/user';
import * as types from './types';
import { logError } from 'utils/logs';
export function fetchUserInfo() {
    var _this = this;
    return function (dispatch, getState) { return __awaiter(_this, void 0, void 0, function () {
        var data, formattedData, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch({ type: types.KYC_USER_FETCH_REQUEST });
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, getKycUser(getState().roles.iss)];
                case 2:
                    data = (_a.sent()).data;
                    formattedData = keysToCamel(data);
                    if (isUser(formattedData)) {
                        dispatch({ type: types.KYC_USER_FETCH_SUCCESS, payload: formattedData });
                    }
                    else {
                        dispatch({ type: types.KYC_USER_FETCH_FAIL });
                    }
                    return [3 /*break*/, 4];
                case 3:
                    err_1 = _a.sent();
                    logError(err_1);
                    dispatch({ type: types.KYC_USER_FETCH_FAIL });
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
}
var isPersonalDetails = function (data) { return typeof data === 'object' && data !== null && 'firstName' in data && 'lastName' in data; };
export function updateUserInfo(user, onSuccess) {
    var _this = this;
    return function (dispatch, getState) { return __awaiter(_this, void 0, void 0, function () {
        var _a, answers, bUser, data, formattedData, err_2;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    dispatch({ type: types.KYC_USER_UPDATE_REQUEST });
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    _a = (isPersonalDetails(user))
                        ? formatPersonalDetailsForBackend(user)
                        : formatPersonalResidenceForBackend(user), answers = _a.answers, bUser = __rest(_a, ["answers"]);
                    return [4 /*yield*/, updateKycUser(getState().roles.iss, bUser)];
                case 2:
                    data = (_b.sent()).data;
                    formattedData = keysToCamel(data);
                    if (isUser(formattedData)) {
                        dispatch({ type: types.KYC_USER_UPDATE_SUCCESS, payload: formattedData });
                        if (onSuccess)
                            onSuccess();
                    }
                    else {
                        dispatch({ type: types.KYC_USER_UPDATE_FAIL, error: 'user_invalid' });
                    }
                    return [3 /*break*/, 4];
                case 3:
                    err_2 = _b.sent();
                    logError(err_2);
                    dispatch({ type: types.KYC_USER_UPDATE_FAIL, error: "".concat(err_2) });
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
}
export function updateUserLegal(user) {
    var _this = this;
    return function (dispatch, getState) { return __awaiter(_this, void 0, void 0, function () {
        var data, formattedData, err_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch({ type: types.KYC_USER_UPDATE_REQUEST });
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, updateKycUser(getState().roles.iss, user)];
                case 2:
                    data = (_a.sent()).data;
                    formattedData = keysToCamel(data);
                    if (isUser(formattedData)) {
                        dispatch({ type: types.KYC_USER_UPDATE_SUCCESS, payload: formattedData });
                    }
                    else {
                        dispatch({ type: types.KYC_USER_UPDATE_FAIL, error: 'user_invalid' });
                    }
                    return [3 /*break*/, 4];
                case 3:
                    err_3 = _a.sent();
                    logError(err_3);
                    dispatch({ type: types.KYC_USER_UPDATE_FAIL, error: "".concat(err_3) });
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
}
export function fetchUserFiles() {
    var _this = this;
    return function (dispatch, getState) { return __awaiter(_this, void 0, void 0, function () {
        var data, formattedData, err_4;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch({ type: types.KYC_USER_FILES_REQUEST });
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, getKycFileUser(getState().roles.iss)];
                case 2:
                    data = (_a.sent()).data;
                    formattedData = keysToCamel(data);
                    if (isUserFiles(formattedData)) {
                        dispatch({ type: types.KYC_USER_FILES_SUCCESS, payload: formattedData });
                    }
                    else {
                        dispatch({ type: types.KYC_USER_FILES_FAIL });
                    }
                    return [3 /*break*/, 4];
                case 3:
                    err_4 = _a.sent();
                    logError(err_4);
                    dispatch({ type: types.KYC_USER_FILES_FAIL });
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
}
export function updateUserFile(type, file) {
    var _this = this;
    return function (dispatch, getState) { return __awaiter(_this, void 0, void 0, function () {
        var formData, data, formattedData, err_5;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    dispatch({ type: types.KYC_USER_FILE_UPDATE_REQUEST });
                    formData = new FormData();
                    formData.append('file', file);
                    formData.append('iss_user', getState().roles.iss.toString());
                    formData.append('type', type);
                    formData.append('name', "".concat(type, "_").concat(getState().roles.iss));
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, uploadKycFileUser(formData)];
                case 2:
                    data = (_c.sent()).data;
                    formattedData = keysToCamel(data);
                    if (isUserFile(formattedData)) {
                        dispatch({ type: types.KYC_USER_FILE_UPDATE_SUCCESS, payload: formattedData });
                    }
                    else {
                        dispatch({ type: types.KYC_USER_FILE_UPDATE_FAIL, error: 'file_invalid' });
                    }
                    return [3 /*break*/, 4];
                case 3:
                    err_5 = _c.sent();
                    logError(err_5);
                    if (axios.isAxiosError(err_5) && ((_a = err_5.response) === null || _a === void 0 ? void 0 : _a.status) === 400) {
                        dispatch({ type: types.KYC_USER_FILE_UPDATE_FAIL, payload: { type: 'client', message: 'invalid_file_type', input: type } });
                    }
                    else if (axios.isAxiosError(err_5) && ((_b = err_5.response) === null || _b === void 0 ? void 0 : _b.status) === 500) {
                        dispatch({ type: types.KYC_USER_FILE_UPDATE_FAIL, payload: { type: 'server', message: 'internal_server_error', input: type } });
                    }
                    else {
                        dispatch({ type: types.KYC_USER_FILE_UPDATE_FAIL, payload: { type: 'client', message: "".concat(err_5), input: type } });
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
}
export function fetchUserAnswers() {
    var _this = this;
    return function (dispatch, getState) { return __awaiter(_this, void 0, void 0, function () {
        var data, formattedData, err_6;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch({ type: types.KYC_USER_ANSWERS_REQUEST });
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, getKycUserAnswer(getState().roles.iss)];
                case 2:
                    data = (_a.sent()).data;
                    formattedData = keysToCamel(data);
                    if (isUserAnswers(formattedData)) {
                        dispatch({ type: types.KYC_USER_ANSWERS_SUCCESS, payload: formattedData });
                    }
                    else {
                        dispatch({ type: types.KYC_USER_ANSWERS_FAIL });
                    }
                    return [3 /*break*/, 4];
                case 3:
                    err_6 = _a.sent();
                    logError(err_6);
                    dispatch({ type: types.KYC_USER_ANSWERS_FAIL });
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
}
export function updateUserAnswers(answers, onSuccess) {
    var _this = this;
    return function (dispatch, getState) { return __awaiter(_this, void 0, void 0, function () {
        var data, formattedData, err_7;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch({ type: types.KYC_USER_ANSWERS_UPDATE_REQUEST });
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, updateKycUserAnswer(getState().roles.iss, keysToSnake(answers))];
                case 2:
                    data = (_a.sent()).data;
                    formattedData = keysToCamel(data);
                    if (isUserAnswers(formattedData)) {
                        dispatch({ type: types.KYC_USER_ANSWERS_UPDATE_SUCCESS, payload: formattedData });
                        if (onSuccess)
                            onSuccess();
                    }
                    else {
                        dispatch({ type: types.KYC_USER_ANSWERS_UPDATE_FAIL, error: 'answers_invalid' });
                    }
                    return [3 /*break*/, 4];
                case 3:
                    err_7 = _a.sent();
                    logError(err_7);
                    dispatch({ type: types.KYC_USER_ANSWERS_UPDATE_FAIL, error: "".concat(err_7) });
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
}
